<app-audit-life-cycle [auditLifeCycleList]="auditLifecycleInput" [boxType]="'status'"></app-audit-life-cycle>